import { get, remove, set } from 'lib/storage/versionedLocalStorageUtils'

// Redux state
// Increment version when we change the state structure in an incompatible way.
const REDUX_SELECTED_TRAVELLER_STATE_KEY = 'BusinessTravellerSelectedTraveller'
const REDUX_SELECTED_TRAVELLER_STATE_VERSION = 2

type BusinessTravellerSelectedTravellerState = {
  employeeIds?: Array<string>
  guestCount?: number
} | undefined

export function saveBusinessTravellerSelectedTravellerState(employeeIds: Array<string>, guestCount?: number) {
  set(REDUX_SELECTED_TRAVELLER_STATE_KEY, REDUX_SELECTED_TRAVELLER_STATE_VERSION, { employeeIds, guestCount: guestCount ?? 0 })
}

export function getBusinessTravellerSelectedTravellerState(): BusinessTravellerSelectedTravellerState {
  return get(REDUX_SELECTED_TRAVELLER_STATE_KEY, REDUX_SELECTED_TRAVELLER_STATE_VERSION)
}

export function clearBusinessTravellerSelectedTraveller() {
  remove(REDUX_SELECTED_TRAVELLER_STATE_KEY)
}

// Trip request room assignments storage
// Used to restore room assignments and guest details when proceeding with booking after approval
const TRIP_REQUEST_ROOM_ASSIGNMENTS_KEY = 'BusinessTravellerTripRequestRoomAssignments'
const TRIP_REQUEST_ROOM_ASSIGNMENTS_VERSION = 1

type TripRequestRoomAssignmentsState = {
  assignments: Array<App.BusinessTraveller.TripRequestRoomAssignment>
} | undefined

export function saveBusinessTravellerTripRequestRoomAssignments(assignments: Array<App.BusinessTraveller.TripRequestRoomAssignment>) {
  set(TRIP_REQUEST_ROOM_ASSIGNMENTS_KEY, TRIP_REQUEST_ROOM_ASSIGNMENTS_VERSION, { assignments })
}

export function getBusinessTravellerTripRequestRoomAssignments(): TripRequestRoomAssignmentsState {
  return get(TRIP_REQUEST_ROOM_ASSIGNMENTS_KEY, TRIP_REQUEST_ROOM_ASSIGNMENTS_VERSION)
}

export function clearBusinessTravellerTripRequestRoomAssignments() {
  remove(TRIP_REQUEST_ROOM_ASSIGNMENTS_KEY)
}
